/* Core & libraries */
import React, { useState, useRef, useEffect } from "react";
import { useTheme } from "react-jss";
import {defineMessages, FormattedMessage, useIntl} from "react-intl";
import {ErrorMessage, Field, Formik, getIn} from "formik";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UCButton from "../../buttons";

/* Helpers, constants, custom methods, internal libraries */
import {
  createValidationPolicyYupSchema,
  useValidationService
} from "../../../resources/validations/validations";

/* Components */

/* Styles */
import styles from "./styles.js"
import {colors} from "../../../constants/colors";


const messages = defineMessages({
  domainPlaceholderMessage: {
    id: 'settings.domains.add.domainPlaceholder'
  },
  emailPlaceholderMessage2: {
    id: 'settings.domains.add.emailAddressPlaceholder2'
  },
})

const Content = props => {
  const { setShowModal, handleSubmit } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  const formRef = useRef(null);
  const intl = useIntl();

  const { addDomainMockedValidationObj } = useValidationService()
  const [testSchema, setTestSchema] = useState({});

  useEffect(() => {
    //TODO: api call to get validations //simpleMockedApiValidationObj
    const result = createValidationPolicyYupSchema(addDomainMockedValidationObj);
    setTestSchema(result)
  }, [])

  const handleFormSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit()
    }
  }

  const submitForm = (values, setSubmitting, setErrors) => {
    const emailDomain = values.emailAddress.split("@")
    const domainsMatch = (values.domain).toLowerCase() === (emailDomain[1]).toLowerCase();
    if (emailDomain[1] && domainsMatch) {
      handleSubmit(values)
    } else {
      const error = <FormattedMessage id={"settings.domains.add.emailAddress.error"} values={{domain: values.domain}} />
      setErrors({emailAddress: error})
    }
    setSubmitting(false);
  }

  return (
    <div className={classes.modalContent}>
      <Formik
        innerRef={formRef}
        initialValues={{
          domain: "",
          emailAddress: "",
        }}
        validationSchema={testSchema}
        onSubmit={(values, { setSubmitting, setErrors }) => {
          submitForm(values, setSubmitting, setErrors);
        }}
      >
        {({
          values,
          errors,
          touched,
          setFieldTouched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
            setFieldValue
          }) => (

          <>
            <form onSubmit={handleSubmit} >
              <div className={classes.inputContainer}>
                <label htmlFor="domain" className={classes.label}>
                  <FormattedMessage id="settings.domains.add.domain"/>
                </label>
                <Field
                  placeholder={intl.formatMessage(messages.domainPlaceholderMessage)}
                  type="text"
                  name="domain"
                  id="domain"
                  className={
                    errors.domain && touched.domain
                      ? "input-error"
                      : null
                  }
                />
                <ErrorMessage
                  name="domain"
                  component="span"
                  className={classes.error}
                />
              </div>
              <div className={classes.inputContainer}>
                <label htmlFor="emailAddress" className={classes.label}>
                  <FormattedMessage id="settings.domains.add.emailAddress"/>
                </label>
                <Field
                  placeholder={intl.formatMessage(messages.emailPlaceholderMessage2, { domain: values.domain })}
                  type="text"
                  name="emailAddress"
                  id="emailAddress"
                  className={
                    errors.emailAddress && touched.emailAddress
                      ? "input-error"
                      : null
                  }
                />
                <ErrorMessage
                  name="emailAddress"
                  component="span"
                  className={classes.error}
                />
              </div>
              <div className={classes.btnContainer}>
                <ContainerFluid>
                  <Row className={classes.btnsRow}>
                    <Col className={classes.colCancel}>
                      <UCButton
                        onClick={() => setShowModal(false)}
                        type="default"
                        className={classes.cancelBtn}
                        text={<FormattedMessage id="settings.domains.add.cancel"/>}
                      />
                    </Col>
                    <Col className={classes.colRemove} >
                      <UCButton
                        className={classes.createBtn}
                        onClick={handleFormSubmit}
                        type="primary"
                        text={<FormattedMessage id="settings.domains.add.button"/>}
                        disabled={!values.domain || !values.emailAddress || Object.values(errors).length > 0}
                        loadingStateStyling={classes.createBtnLoadingStateStyling}
                        spinner={{
                          name: "addDomainSpinner",
                          size: 20,
                        }}
                      />
                    </Col>
                  </Row>
                </ContainerFluid>
              </div>
            </form>
          </>
        )}
      </Formik>
    </div>
  )
}

export default Content;
